import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountCategoryList, AccountSubCategoryList } from '@app/modules/fund-management/accounts/models/account-categories';

@Injectable()
export class AccountCategoryService {
	endpoint = '/api/account-categories';
	subcategoryEndpoint = '/api/account-subcategories';

	constructor(private readonly $http: HttpClient) {}

	getCategories(): Observable<AccountCategoryList> {
		return this.$http.get<AccountCategoryList>(this.endpoint);
	}

	getAllSubcategories() {
		return this.getSubcategories(null);
	}

	getSubcategories(categoryId): Observable<AccountSubCategoryList> {
		return this.$http.get<AccountSubCategoryList>(this.subcategoryEndpoint, {
			params: { categoryId },
		});
	}

	addCategory(categoryDescription) {
		return this.$http.post(this.endpoint, {
			Description: categoryDescription,
		});
	}

	updateCategory(id, categoryDescription) {
		return this.$http.put(this.endpoint + '/' + id, {
			Id: id,
			Description: categoryDescription,
		});
	}

	deleteCategory(id) {
		return this.$http.delete(this.endpoint + '/' + id);
	}

	addSubcategory(categoryId, subcategoryDescription) {
		return this.$http.post(this.subcategoryEndpoint, {
			CategoryId: categoryId,
			Description: subcategoryDescription,
		});
	}

	updateSubcategory(id, categoryId, subcategoryDescription) {
		return this.$http.put(this.subcategoryEndpoint + '/' + id, {
			Id: id,
			CategoryId: categoryId,
			Description: subcategoryDescription,
		});
	}

	deleteSubcategory(id) {
		return this.$http.delete(this.subcategoryEndpoint + '/' + id);
	}
}
